import React, { Component, Fragment } from 'react';
import { css } from 'aphrodite/no-important';
import styles from './TitleBar.styles';

import Button from '../../inputs/button/Button';
import Icon from '../icon/Icon';

export class TitleBar extends Component {
  state = {
    title: this.props.title,
    editable: false,
    enteredIcon: false
  };
  toggle = () => {
    this.setState({ editable: !this.state.editable });
    if (!this.state.editable) {
      setTimeout(() => {
        const range = document.createRange();
        const sel = window.getSelection();
        range.selectNodeContents(this.refs.title);
        range.collapse(false);
        sel.removeAllRanges();
        sel.addRange(range);
        this.refs.title.focus();
        range.detach();
      }, 0);
    }
  };
  toggleMouseEvent = () => {
    this.setState({ enteredIcon: !this.state.enteredIcon });
  };
  handleBlur = ({ target }) => {
    // this.props.handleEdit(target.innerText);
    if (!this.state.enteredIcon) {
      this.setState({ editable: false });
    }
  };
  handleKeyPress = e => {
    if ((e.charCode || e.keyCode) === 13) {
      this.props.handleEdit(e.target.innerText);
      this.setState({ editable: false });
    }
  };
  render() {
    const {
      styles: customStyles,
      handleAdd,
      handleEdit,
      title,
      btn,
      editable,
      onEdit,
      ...rest
    } = this.props;
    return (
      <div className={css(styles.base, customStyles)} {...rest}>
        <span className={css(styles.title)}>
          {editable && (
            <Fragment>
              <span
                contentEditable={this.state.editable}
                onKeyPress={this.handleKeyPress}
                onBlur={this.handleBlur}
                ref="title"
              >
                {this.state.title}
              </span>
              <Icon
                value="pencil"
                styles={styles.icon}
                onClick={this.toggle}
                onMouseEnter={this.toggleMouseEvent}
                onMouseLeave={this.toggleMouseEvent}
              />
            </Fragment>
          )}
          {!editable && <span>{this.props.title}</span>}
        </span>
        <Button onClick={handleAdd} styles={styles.btn}>
          {btn}
        </Button>
      </div>
    );
  }
}

export default TitleBar;



// WEBPACK FOOTER //
// ./src/components/common/titlebar/TitleBar.js